import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router/es/withRouter';
import Callback from './Callback';

import { loadUser } from '../ducks/user';

class AuthProvider extends Component {
  constructor(props) {
    super(props);
    this.um = props.userManager;
  }

  getChildContext() {
    return {
      userManager: this.um
    };
  }

  componentDidMount() {
    if (this.props.user.name === '') {
      const pl = this.props.userManager.getIdTokenPayload();
      if (pl !== null) {
        this.props.loadUser(pl);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user.name !== nextProps.user.name) {
      nextProps.loadUser(nextProps.userManager.getIdTokenPayload());
    }
    if (this.props.user.name === '' && nextProps.user.name !== '') {
      this.um.startSessionIframe();
    }
  }

  render() {
    const { location } = this.props;
    if (location.pathname === '/_cb') {
      return <Callback {...this.props} />;
    }
    if (this.um.isAuthenticated()) {
      return (
        <div>
          {React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
              userManager: this.props.userManager,
              user: this.props.user
            });
          })}
        </div>
      );
    } else {
      this.um.signin({ path: this.props.location.pathname + this.props.location.search });
      return null;
    }
  }
}

AuthProvider.propTypes = {
  children: PropTypes.node,
  userManager: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  loadUser: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired
};

AuthProvider.childContextTypes = {
  userManager: PropTypes.object
};

const mapState = ({ user }) => ({ user: user.idTokenData });
const mapDispatch = dispatch => ({ loadUser: bindActionCreators(loadUser, dispatch) });

export default withRouter(connect(mapState, mapDispatch)(AuthProvider));



// WEBPACK FOOTER //
// ./src/common/jsx/auth/AuthProvider.js